//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { attendanceDays } from 'api/Attendance/monthly-statistics';
export default {
  data: function data() {
    return {
      title: '',
      tableColumns: [],
      form: {
        count: 0,
        page: 1,
        // 分页页码
        page_size: 20,
        // 是每页条数
        start_date: '',
        // 开始时间
        end_date: '',
        // 结束时间
        staff_id: '',
        // 员工ID
        type: '',
        // 类型 1出勤天数详情、2出勤时长详情、3缺勤天数详情、4休息日详情、5公共假期、6缺卡次数、7迟到详情、8早退详情、9请假详情、10出差、11休息日上班详情、12工作日加班详情、13休息日加班详情
        month_cycle_id: '' // 周期ID（获取出勤天数详情时必填）
      },

      visible: false,
      tableData: [],
      tableLoading: false
    };
  },
  methods: {
    init: function init(form) {
      // console.log(form)
      this.visible = true;
      // 默认以传参为准
      this.form = Object.assign(this.form, form);
      // 获取表格详情
      this.getAttendanceDays();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.page = val;
      this.getAttendanceDays();
    },
    // 获取表格数据
    getAttendanceDays: function getAttendanceDays() {
      var _this = this;
      attendanceDays(this.form).then(function (res) {
        var _res$data = res.data,
          head = _res$data.head,
          data_list = _res$data.data_list,
          total_count = _res$data.total_count,
          title = _res$data.title;
        _this.tableColumns = head;
        _this.tableData = data_list;
        _this.form.count = total_count;
        // 弹窗标题
        _this.title = title;
      });
    }
  }
};